// Stub — audit context not used in standalone Talents project
export function consumeAuditContext(): Record<string, string> {
  return {};
}

export function setAuditContext(_ctx: Record<string, string>): void {}
